import React from "react";
import Marquee from "react-fast-marquee";

export interface Announcement {
  ID: number;
  thought: string;
  featured: string;
  created_date: string;
}

interface DashboardAnnouncementsProps {
  announcements: Announcement[];
}

const DashboardAnnouncements: React.FC<DashboardAnnouncementsProps> = ({
  announcements,
}) => {
  return (
    <div className="announcement-bar-white">
      <Marquee
        speed={50}
        gradient={false}
        pauseOnHover={true}
        className="fw-semibold"
      >
        {announcements.slice(0, 9).map((item) => (
          <span
            key={item.ID}
            className="mx-5 text-dark"
            dangerouslySetInnerHTML={{ __html: `📢 ${item.thought}` }}
          />
        ))}
      </Marquee>
    </div>
  );
};

export default DashboardAnnouncements;

// import React from "react";
// import Marquee from "react-fast-marquee";

// const DashboardAnnouncements = () => {
//     const announcements = [
//         "📢 Company Annual Sports Day on 5th September!",
//         "📢 New HR Policies effective from next month.",
//         "📢 Festival Celebration on 15th September – Don’t miss it!",
//         "📢 Festival Celebration on 15th September – Don’t miss it!"
//     ];

//     return (
//         <div className="announcement-bar-white">
//             <Marquee
//                 speed={50}
//                 gradient={false}
//                 pauseOnHover={true}
//                 className="fw-semibold"
//             >
//                 {announcements.map((item: any, index: number) => (
//                     <span key={index} className="mx-5 text-dark">
//                         {item}
//                     </span>
//                 ))}
//             </Marquee>
//         </div>
//     );
// };

// export default DashboardAnnouncements;
